import { apiUrl, putJson } from './httpClient';

/**
 * Fetch the authenticated customer's profile.
 * @param {string} token
 * @returns {Promise<{ id: string, name: string, email: string, phone: string }>}
 */
export async function fetchProfile(token) {
  const res = await fetch(apiUrl('/profile'), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  const json = res.ok ? await res.json() : null;
  if (!json?.success) throw new Error(json?.message || 'Could not load profile');
  return json?.data?.customer ?? {};
}

/**
 * Update the authenticated customer's profile.
 * @param {{ name?: string, phone?: string }} payload
 * @param {string} token
 * @returns {Promise<{ id: string, name: string, email: string, phone: string }>}
 */
export async function updateProfile(payload, token) {
  const json = await putJson('/profile', {
    body: payload,
    token,
    globalLoading: false,
  });
  if (!json?.success) throw new Error(json?.message || 'Could not update profile');
  return json?.data?.customer ?? {};
}
